<mojo-lister entityName="Vacant"
             [ownerEntityKey]="entityKey$ | async"
             (onRowSelect)="handleRowSelect($event)"
             [getRowHref]="getRowHref">
</mojo-lister>
